import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.items = this.el.querySelectorAll('.js-vertical-slider-item');

        // for each item get height of the bigger one and create a css variable
        let maxHeight = 0;
        this.items.forEach(item => {
            const height = item.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        this.el.style.setProperty('--max-height', `${maxHeight}px`);
        
        // calc on resize
        window.addEventListener('resize', () => {
            let maxHeight = 0;
            this.items.forEach(item => {
                const height = item.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            this.el.style.setProperty('--max-height', `${maxHeight}px`);
        }
        );
    }
}
